<template>
  <nx-relation-card-collapsed :key="uuid"
                              :title="name"
                              :draggable="draggable"
                              icon="web"
                              dark
                              v-on="$listeners"/>
</template>
<script>
import NxRelationCardCollapsed from '@/modules/relation/card/CardCollapsed';

export default {
  name: 'nx-scrollytelling-slide-list-item',
  components: { NxRelationCardCollapsed },
  props: {
    uuid: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    draggable: {
      type: Boolean,
    },
  },
};
</script>
